import { Trophy } from 'lucide-react';
import { getLevelInfo } from '../../utils/scoring';

export const LogView = ({
  sendItScore,
  longestStreak,
  streak,
  logs,
  pendingOutcomes,
  testOutcome,
}) => {
  return (
    <div className="space-y-4 animate-fade-in">
      <div className="bg-gradient-to-r from-orange-600 to-red-600 border-3 sm:border-4 border-orange-400 p-4 sm:p-5 skew-x-[-2deg]">
        <h2 className="text-3xl sm:text-4xl font-black text-white uppercase tracking-tight skew-x-[2deg]">YOUR HISTORY</h2>
      </div>

      {sendItScore > 0 && (
        <div className="space-y-4">
          {/* New Stats Section */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {/* Longest Streak */}
            <div className="bg-gradient-to-br from-purple-900 to-indigo-900 border-4 border-purple-500 p-4">
              <div className="text-center">
                <Trophy className="text-purple-400 mx-auto mb-2" size={32} />
                <div className="text-4xl font-black text-purple-400 mb-1">{longestStreak}</div>
                <div className="text-xs font-black text-purple-300 uppercase">Longest Streak</div>
                {longestStreak === streak && streak > 0 && (
                  <div className="text-xs text-lime-400 font-bold mt-1">🔥 ACTIVE NOW!</div>
                )}
              </div>
            </div>



          </div>

          <div className={`bg-gradient-to-br ${getLevelInfo(sendItScore).currentLevel.bg} border-4 border-black p-4 sm:p-6`}>
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-2xl sm:text-3xl font-black text-white uppercase">CURRENT LEVEL</h3>
              <span className={`text-3xl sm:text-4xl font-black ${getLevelInfo(sendItScore).currentLevel.color}`}>
                {getLevelInfo(sendItScore).currentLevel.title}
              </span>
            </div>
            {getLevelInfo(sendItScore).nextLevel && (
              <div>
                <div className="bg-black/50 h-4 w-full mb-2">
                  <div
                    className="bg-lime-400 h-full transition-all duration-500"
                    style={{ width: `${getLevelInfo(sendItScore).progress}%` }}
                  ></div>
                </div>
                <div className="flex justify-between text-sm font-black text-white/90">
                  <span>{sendItScore} POINTS</span>
                  <span>{getLevelInfo(sendItScore).nextLevel.min - sendItScore} TO {getLevelInfo(sendItScore).nextLevel.title}</span>
                </div>
              </div>
            )}
          </div>


        </div>
      )}

      {(logs && logs.length === 0) ? (
        <div className="bg-gray-900 border-3 sm:border-4 border-gray-700 p-8 sm:p-10 text-center">
          <p className="font-black text-gray-500 text-xl sm:text-2xl uppercase tracking-wide">NO CHALLENGES LOGGED • START NOW</p>
        </div>
      ) : (
        logs && logs.map(log => (
          <div
            key={log.id}
            className={`p-4 sm:p-6 border-3 sm:border-4 ${log.swapped
              ? 'bg-gradient-to-r from-yellow-900/30 to-gray-900 border-yellow-600'
              : log.isHardMode && log.success
                ? 'bg-gradient-to-r from-red-900/40 to-gray-900 border-red-500'
                : log.success
                  ? log.isCustom
                    ? 'bg-gradient-to-r from-purple-500/20 to-indigo-500/20 border-purple-500'
                    : 'bg-gradient-to-r from-lime-500/20 to-green-500/20 border-lime-500'
                  : 'bg-gray-900 border-gray-700'
              }`}
          >
            <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3 sm:gap-4">
              <div className="flex-1">
                <p className="font-black mb-2 text-lg sm:text-xl uppercase tracking-tight text-white">{log.challenge}</p>
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <p className="text-sm font-black text-gray-400 uppercase">{log.date}</p>
                  {log.isHardMode && (
                    <span className="text-xs font-black px-2 py-1 bg-red-900 text-red-300 border border-red-600">
                      💀 HARD MODE
                    </span>
                  )}
                  {log.swapped && (
                    <span className="text-xs font-black px-2 py-1 bg-yellow-500 text-black">
                      🔀 SWAPPED
                    </span>
                  )}
                  {log.isCustom && (
                    <span className="text-xs font-black px-2 py-1 bg-purple-600 text-white">
                      CUSTOM
                    </span>
                  )}
                  {log.isWeekly && (
                    <span className="text-xs font-black px-2 py-1 bg-yellow-600 text-black">
                      WEEKLY
                    </span>
                  )}
                  {log.success && !log.isCustom && (
                    <span className="text-xs font-black text-lime-400">
                      +{log.earnedPoints || log.points} pts
                      {log.recoveryBonus && <span className="text-orange-400"> (2X RECOVERY!)</span>}
                    </span>
                  )}
                  {log.autoBitched && (
                    <span className="text-xs font-black px-2 py-1 bg-red-900 text-red-300">
                      AUTO-BITCHED (TIME EXPIRED)
                    </span>
                  )}
                  {log.outcome && (
                    <span className={`text-xs font-black px-2 py-1 ${log.outcome === 'positive' ? 'bg-green-600 text-white' :
                      log.outcome === 'pending' ? 'bg-yellow-600 text-black' :
                        'bg-red-600 text-white'
                      }`}>
                      {log.outcome === 'positive' ? '👍 WORKED' :
                        log.outcome === 'pending' ? '🤷 PENDING' :
                          '👎 FAILED'}
                    </span>
                  )}
                </div>
                {log.success && !log.outcome && pendingOutcomes.includes(log.id) && (
                  <button
                    onClick={() => testOutcome(log.id)}
                    className="text-xs font-black px-2 py-1 bg-blue-600 hover:bg-blue-500 text-white border-2 border-blue-400 mt-2"
                  >
                    [TEST: ADVANCE 24H]
                  </button>
                )}
              </div>
              <span className={`font-black text-base sm:text-lg px-4 sm:px-6 py-2 sm:py-3 border-3 self-start ${
                log.swapped
                  ? 'bg-yellow-500 text-black border-yellow-400'
                  : log.isHardMode && log.success
                    ? 'bg-red-600 text-white border-red-400'
                    : log.success
                      ? 'bg-lime-500 text-black border-lime-400'
                      : 'bg-gray-800 text-gray-400 border-gray-700'
              }`}>
                {log.swapped ? 'SWAPPED' : log.isHardMode && log.success ? '💀 SENT (HARD)' : log.success ? 'SENT' : 'BITCHED OUT'}
              </span>
            </div>
          </div>
        ))
      )}

    </div>
  );
};
